import styles from './Switch.module.less';

const Switch = ({
  id,
  'data-on': dataOn,
  'data-off': dataOff,
  name,
  label,
  size = 'medium',
  value,
  disabled,
  checked,
  icon,
  readonly,
  handleChange,
  labelClassName = 'text-weight-regular',
  dataClassName = 'text-weight-semi-bold',
}) => {
  /* istanbul ignore next */
  const switchId = id || Math.random().toString(36).substr(2);

  // TODO: Trocar data-on/off por label
  return (
    <div className={styles.root}>
      <div className={labelClassName}>{label}</div>
      <div className={`br-switch ${size} ${icon ? 'icon' : ''}`}>
        <input
          id={switchId}
          type="checkbox"
          checked={checked}
          value={value}
          name={name}
          disabled={disabled}
          readOnly={readonly}
          onChange={
            handleChange && typeof handleChange === 'function'
              ? () => handleChange(!checked)
              : null
          }
        />
        <label htmlFor={switchId} className={dataClassName}>
          {checked ? dataOn : dataOff}
        </label>
      </div>
    </div>
  );
};

export default Switch;
